/**
 * Функция, высчитывающая отступы элемента от его offset-родителя
 *
 * Учитывает что offsetParent может быть скроллящимся
 *
 * @param element Элемент, позицию которого относительно родителя хотим получить
 * @returns Дробные отступы элемента от его родителя
 */
export function getParentOffsets(element: HTMLElement) {
    const parent = element.offsetParent;

    if (!parent) {
        return;
    }

    const elementClientRect = element.getBoundingClientRect();

    // Позиция от viewport минус позиция скролла в контейнере
    const parentLeft = parent.getBoundingClientRect().left - parent.scrollLeft;
    // Позиция от viewport
    const activeTabLeft = elementClientRect.left;

    const parentRight = parent.getBoundingClientRect().right - parent.scrollLeft;
    const activeTabRight = elementClientRect.right;

    const parentBottom = parent.getBoundingClientRect().bottom - parent.scrollTop;
    const activeTabBottom = elementClientRect.bottom;

    const parentTop = parent.getBoundingClientRect().top - parent.scrollTop;
    const activeTabTop = elementClientRect.top;

    return {
        left: activeTabLeft - parentLeft,
        right: parentRight - activeTabRight,
        bottom: parentBottom - activeTabBottom,
        top: activeTabTop - parentTop,
    };
}
